<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="uploadtrackerconfirm()"><i class="fa fa-upload"></i> UPLOAD TRACKER</b-button>
          <b-button variant="primary mr-1" @click="reconTracker()"><i class="fa fa-exchange"></i> RECON</b-button>
          <b-button variant="primary mr-1" @click="reconRecheck()"><i class="fa fa-exchange"></i> RE-CHECK</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="12">
            <b-input-group>
              <b-input-group-prepend>
              <label>Trx. Date</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" style="max-width:80px"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" style="max-width:80px"></b-form-input>
              <b-input-group-prepend>
                <label class="text-right">Project</label>
              </b-input-group-prepend>
              <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>  
              <b-button class="btn btn-success ml-1" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" responsive outlined  striped hover small style="font-size:small;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked" show-empty :busy="isBusy"
        :tbody-tr-class="rowClass" sticky-header="800px"
        >
        <template #thead-top="data">
          <b-tr>
            <b-th colspan="2"></b-th>
            <b-th variant="primary" colspan="2" class="text-center">DISBURSEMENT</b-th>
            <b-th variant="success" colspan="2" class="text-center">TOP UP</b-th>
            <b-th variant="info" colspan="6" class="text-center">REPAYMENT</b-th>
            <b-th variant="success" colspan="6" class="text-center">REPAYMENT REAL</b-th>
            <!-- <b-th variant="warning" colspan="3" class="text-center">OUTSTANDING</b-th> -->
          </b-tr>
        </template>
        <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
        <template v-slot:cell(trxDate)="data">{{ data.item.trxDate | moment("YYYY MMM DD")}}</template>
        <template v-slot:cell(disbursement_amount_system)="data"><span :class="data.item.isDisbursementReconciled==0?'text-danger':''">{{ data.item.disbursement_amount_system | numFormat('0,0.00')}}</span></template>
        <template v-slot:cell(disbursement)="data">{{ data.item.disbursement | numFormat('0,0.00')}}</template>
        <template v-slot:cell(top_up_system)="data">{{ data.item.top_up_system | numFormat('0,0.00')}}</template>
        <template v-slot:cell(topUp)="data">{{ data.item.topUp | numFormat('0,0.00')}}</template>
        <template v-slot:cell(total_repayment_system)="data"><span :class="data.item.isRepaymentReconciled==0?'text-danger':''">{{ data.item.total_repayment_system | numFormat('0,0.00')}}</span></template>
        <template v-slot:cell(principal_repayment_system)="data">{{ data.item.principal_repayment_system | numFormat('0,0.00')}}</template>
        <template v-slot:cell(interest_repaid_system)="data">{{ data.item.interest_repaid_system | numFormat('0,0.00')}}</template>
        <template v-slot:cell(repaymentTotal)="data">{{ data.item.repaymentTotal | numFormat('0,0.00')}}</template>
        <template v-slot:cell(repaymentPrincipalRefund)="data">{{ data.item.repaymentPrincipalRefund | numFormat('0,0.00')}}</template>
        <template v-slot:cell(repaymentInterest)="data">{{ data.item.repaymentInterest | numFormat('0,0.00')}}</template>
        <template v-slot:cell(repaymentInterestAfterTax)="data">{{ data.item.repaymentInterestAfterTax | numFormat('0,0.00')}}</template>
        <template v-slot:cell(reconcileBy)="data">
          <span v-if="(data.item.reconcileBy)">
            {{ data.item.reconcileBy}} - {{ data.item.reconcileAt | moment("YYYY MMM DD HH:mm")}}
          </span>  
        </template>
        <template v-slot:cell(withdrawTotal)="data">{{ data.item.withdrawTotal | numFormat('0,0.00')}}</template>
        <template v-slot:cell(withdrawPrincipal)="data">{{ data.item.withdrawPrincipal | numFormat('0,0.00')}}</template>
        <template v-slot:cell(withdrawInterest)="data">{{ data.item.withdrawInterest | numFormat('0,0.00')}}</template>
        <template v-slot:cell(withdrawInterestAfterTax)="data">{{ data.item.withdrawInterestAfterTax | numFormat('0,0.00')}}</template>
        <template v-slot:cell(withdrawTaxAmt)="data">
          <span :class="data.item.withdrawTotal>0 && data.item.withdrawTaxAmt ==0  ?'text-danger':''">
            {{ data.item.withdrawTaxAmt | numFormat('0,0.00')}}
          </span>
        </template>
        <template #custom-foot="data">
          <b-tr style="font-size: medium;">
            <b-th colspan="2">TOTAL</b-th>
            <b-th v-for="(dt) in tblData.sumKeys" :key="dt" class="text-right">
              {{ tblData[dt] | numFormat('0,0.00')}}
            </b-th>
            <b-th colspan="12"></b-th>
          </b-tr>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25,50,75,100]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width:80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="uploadtrackerconfirmShow" title="Upload Channeling Tracker ?" :centered="true" @ok="uploadtracker" size="lg" >
      <b-input-group>
        <b-input-group-prepend class="mr-2">
          <label>Period</label>
        </b-input-group-prepend>
        <b-form-input v-model="tblDataTracker.tgl1" type="date" style="max-width:100px"></b-form-input>
        <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
        <b-form-input v-model="tblDataTracker.tgl2" type="date" style="max-width:100px"></b-form-input>
        <b-input-group-prepend>
          <label class="text-right">Project</label>
        </b-input-group-prepend>
        <b-form-select v-model="tblDataTracker.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>  
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend class="mr-2">
          <label>Selected File</label>
        </b-input-group-prepend>
        <b-form-file
          v-model="file"
          :state="Boolean(file)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
      </b-input-group>

    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>

  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import myNumber from "../../components/my-number.vue";
import crud from "../../apis/crud";
import trxtracker from "../../apis/trxtracker";

toastr.init();
export default {
  components: { Loading ,myNumber},
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      uploadtrackerconfirmShow:false,
      type_os_options: [
        { value: null, text: 'Please select an option' },
        { value: 'principal', text: 'Principal' },
        { value: 'interest', text: 'Interest' },
        { value: 'OS', text: 'OS Total' },

      ],
      projectsFilt:[
        // {value:'',text:'-- ALL --',disabled:true}
    ],
      disbursement_options: [
        { value: null, text: 'Please select an option' },
        { value: 'principal', text: 'Principal' },
        { value: 'interest', text: 'Interest' },
      ],
      comparison_option: [
        { value: null, text: 'Please select an option' },
        { value: '=', text: 'Equal to' },
        { value: '>', text: 'Greater than' },
        { value: '>=', text: 'greater than or equal to' },
        { value: '<', text: 'Less than' },
        { value: '<=', text: 'less than or equal to' },
      ],
      file:null,
      tblData: {
        items: [],
        page: 1,
        limit: 25,
        total: 0,
        sortBy: "trxDate",
        sortDesc: true,
        tablename: 'transactiontracker',
        tgl1: moment().subtract(1,'M').startOf('M').format('YYYY-MM-DD'), tgl2: moment().format('YYYY-MM-DD'),
        loan_id: '',
        customerID: '', debtorFullName: '', type_os: 'principal', comparison: '>',osamt:0,
        type_disbursement: 'principal', comparison_disbuesement: '>',disbursement_amount:0,
        pjxkey: 'FD401D90-6885-11ED-829E-C1644A8D7D96',
        pjxName:"",
      },
      tblDataTracker:{
        tgl1: moment().startOf('M').format('YYYY-MM-DD'), tgl2: moment().format('YYYY-MM-DD'),pjxkey: 'FD401D90-6885-11ED-829E-C1644A8D7D96',
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
        },
         {
          key: "trxDate",
          label: "Trx. Date",
          thClass: "text-center",
          thStyle: "min-width:120px",
          sortable: true
        },
        {
          key: "disbursement_amount_system",
          label: "Disbursement Amt (SYSTEM)",
          thClass: "text-center",
          tdClass: 'text-right',
          variant: 'primary'
        },
        {
          key: "disbursement",
          label: "Disbursement Amt",
          thClass: "text-center",
          tdClass: 'text-right',
        },
        {
          key: "top_up_system",
          label: "TOP UP Amt (SYSTEM)",
          thClass: "text-center",
          tdClass: 'text-right',
          variant: 'success'
        },
        {
          key: "topUp",
          label: "TOP UP Amt",
          thClass: "text-center",
          tdClass: 'text-right',
        },
        {
          key: "total_repayment_system",
          label: "TOTAL REPAYMENT SYSTEM",
          thClass: "text-center",
          tdClass: 'text-right',
          variant: 'info'
        },
        {
          key: "repaymentTotal",
          label: "TOTAL REPAYMENT",
          thClass: "text-center",
          tdClass: 'text-right',
        },
        {
          key: "principal_repayment_system",
          label: "Principal+Refund Amt. (SYSTEM)",
          thClass: "text-center",
          tdClass: 'text-right',
          variant: 'info'
        },
        {
          key: "repaymentPrincipalRefund",
          label: "Principal+Refund Amt.",
          thClass: "text-center",
          tdClass: 'text-right',
        },
        {
          key: "interest_repaid_system",
          label: "Interest Amt. SYSTEM",
          thClass: "text-center",
          tdClass: 'text-right',
          variant: 'info'
        },
        {
          key: "repaymentInterest",
          label: "Interest Amt.",
          thClass: "text-center",
          tdClass: 'text-right',
        },
        {
          key: "withdrawPrincipal",
          label: "Principal",
          thClass: "text-center",
          tdClass: 'text-right',
          variant: 'success'
        },
        {
          key: "withdrawInterestAfterTax",
          label: "Interest After Tax",
          thClass: "text-center",
          tdClass: 'text-right',
        },
        {
          key: "withdrawTaxAmt",
          label: "Tax Amt.",
          thClass: "text-center",
          tdClass: 'text-right',
          variant: 'success'
        },
        {
          key: "reconcileBy",
          label: "RECONCILE",
          thClass: "text-center",
          thStyle: "min-width:200px",
          sortable: true
        },  
      ];
      return fields;
    },
    progessupload() {
      let progessupload = this.$store.state.progessupload;
      if (progessupload && progessupload.refreshdata) {
        this.refresh();
        this.$refs["modalprogress"].hide();
        this.$store.commit("progessupload", {});
      }
      return progessupload;
    },
  },
  watch:{
    'tblData.pjxkey':function(newVal){
      this.tblDataTracker.pjxkey = newVal;
      let findProject = this.projectsFilt.find(x=>x.value==newVal);
      if(findProject){
        this.tblData.pjxName = findProject.text;
      }
    },
    'tblDataTracker.pjxkey':async function(){
      const dtSet = await trxtracker.getLastReconDate(this.tblDataTracker);
      this.tblDataTracker.tgl1= moment(dtSet.lastDate).format('YYYY-MM-DD');
      this.tblDataTracker.tgl2= moment(dtSet.endDate).format('YYYY-MM-DD');
    }
  },
  async created() {
    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
    })]);

    projects.forEach(tp => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
    });
    
    this.$store.commit("progessupload", {});
    let findProject = this.projectsFilt.find(x=>x.value==this.tblData.pjxkey);
    if(findProject){
      this.tblData.pjxName = findProject.text;
      console.log('this.tblData.pjxName',this.tblData.pjxName)
    }
    
  },
  methods: {
    rowClass(item, type) {
      if (item==null) return;
      if (item.isReconciled === 0) return 'table-warning'
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || "") == "") {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
        }
        const list= await trxtracker.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        this.tblData.tblFields = JSON.stringify(this.tblFields);
        await trxtracker.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async uploadtrackerconfirm(){
      try {
        const dtSet = await trxtracker.getLastReconDate(this.tblDataTracker);
        this.tblDataTracker.tgl1= moment(dtSet.lastDate).format('YYYY-MM-DD');
        this.tblDataTracker.tgl2= moment(dtSet.endDate).format('YYYY-MM-DD');
        this.uploadtrackerconfirmShow =true;
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async uploadtracker() {
      try {
        this.isLoading=true;
        await trxtracker.transactiontrackerupload(this.file,this.tblDataTracker);
        this.isLoading=false;
        toastr.success('UPLOAD SUCCESFULLY', "SUCCESS", 10000);
      } catch (error) {
        this.isLoading=false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },

    async reconTracker(){
      try {
        this.isLoading=true;
        await trxtracker.reconTracker(this.tblData);
        this.isLoading=false;
        toastr.success('UPLOAD SUCCESFULLY', "SUCCESS", 10000);
      } catch (error) {
        this.isLoading=false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    async reconRecheck(){
      try {
        this.isLoading=true;
        await trxtracker.reconRecheck(this.tblData);
        this.isLoading=false;
        toastr.success('UPLOAD SUCCESFULLY', "SUCCESS", 10000);
      } catch (error) {
        this.isLoading=false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 25,
        total: 0,
        sortBy: "trxDate",
        sortDesc: true,
        tablename: 'transactiontracker',
        loan_id: '', tgl1: '', tgl2: ''
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    }
  }
};
</script>